import { Link } from 'react-router-dom';
import { ArrowLeft, Smartphone } from 'lucide-react';

export default function MobilePreviewPage() {
  const fletUrl = `${process.env.REACT_APP_BACKEND_URL}/api/flet-app/`;

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col items-center py-8 px-4">
      <div className="w-full max-w-xl flex items-center gap-3 mb-4">
        <Link
          to="/dashboard"
          className="flex items-center gap-1.5 text-sm text-slate-400 hover:text-white transition-colors"
          data-testid="back-to-dashboard"
        >
          <ArrowLeft size={16} /> Back to Web App
        </Link>
      </div>

      <div className="flex items-center gap-2 mb-1">
        <Smartphone className="text-green-400" size={20} />
        <h1 className="text-xl font-bold text-white" style={{ fontFamily: 'Manrope, sans-serif' }}>
          Mobile App Preview
        </h1>
      </div>
      <p className="text-slate-400 text-sm mb-5 text-center">
        Live preview of the Flet app &mdash; same code compiles to iOS &amp; Android.
      </p>

      <div
        className="relative bg-slate-950 rounded-[2.5rem] p-3 shadow-2xl shadow-black/50"
        style={{ width: 390, maxWidth: '95vw' }}
        data-testid="phone-frame"
      >
        {/* Notch */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-28 h-6 bg-slate-950 rounded-b-2xl z-10" />

        <div className="rounded-[2rem] overflow-hidden bg-white" style={{ height: 720 }}>
          <iframe
            src={fletUrl}
            title="Jump Smash Mobile"
            className="w-full h-full border-0"
            data-testid="flet-iframe"
          />
        </div>

        {/* Home indicator */}
        <div className="flex justify-center mt-2">
          <div className="w-28 h-1 bg-slate-600 rounded-full" />
        </div>
      </div>
    </div>
  );
}
